/**
 * Created by BFR on 14/04/2022.
 */
define('configPrintAreaItemView',['module',
    'backbone',
    'jquery',
    'underscore',
    'marionette',
    'settings',
    'previewPopover',
    'imageUploadBehavior',
    'template!configPrintAreaItemTpl'],
  function (module,
            Backbone,
            $,
            _,
            Marionette,
            Settings,
            PreviewPopover,
            ImageUploadBehavior,
            tpl) {
    'use strict';

    module.exports = Marionette.ItemView.extend({
      template: tpl,
      className: 'config-option-row printzone-item-selection',

      ui: {
        uploadImageBlock: '.upload-image-block',
        imageContainer: '.image-ctn',
        imageSelected: '.image-selected',
        deleteButton: '.delete-button',
        previewThumb: '.js-config-printarea-thumb'
      },

      events: {
        'click .dropdown-menu-printzone a': 'onChangePrintZone',
        'click @ui.deleteButton': 'onDelete'
      },

      serializeData: function () {
        var templateData = this.model.toJSON();
        templateData.advancedMode = !!Settings.configValue('advancedMode');
        return templateData;
      },

      applyPreviewImages: function (pzPictures) {
        var printZones = this.model.get('printZones') || [];
        var firstPz = printZones[0];
        if (firstPz && pzPictures[firstPz.id] && pzPictures[firstPz.id].length > 0) {
          PreviewPopover.attach(this.ui.previewThumb, pzPictures[firstPz.id][0].imageUrl, {namespace: 'configPaZoom'});
        }
        this.$('.js-config-pz-thumb').each(function () {
          var $img = $(this);
          var pictures = pzPictures[$img.attr('data-pz-id')] || [];
          if (pictures.length > 0) {
            PreviewPopover.attach($img, pictures[0].imageUrl, {namespace: 'configPzZoom'});
          }
        });
      },

      onDestroy: function () {
        this.$('.js-config-printarea-thumb, .js-config-pz-thumb').each(function () {
          PreviewPopover.detach($(this));
        });
        $('.jqgrid-popover').remove();
      },

      behaviors: {
        ImageUpload: {
          behaviorClass: ImageUploadBehavior
        }
      },

      notShowRemoveBackgroundPopup: true,
      loadImageInMemory: true,

      onImageUploadConfirm: function (base64Value, fileExt, property, fileName) {
        this.ui.imageSelected.attr('src', 'data:image/png;base64,' + base64Value);
        this.ui.uploadImageBlock.hide();
        this.ui.imageContainer.show();
        this.trigger('selected:printzone:image:change', this.model.get('id'), this.currentPzId, {
          content: base64Value,
          extension: fileExt,
          name: fileName
        });
      },

      onChangePrintZone: function (e) {
        e.preventDefault();
        var target = $(e.currentTarget),
          nbrColor = target.data('nb-color');
        this.currentPzId = target.data('pzId');
        var labelText = target.find('.config-pz-label').text() || target.text();
        this.$el.find('.printzone-label').text(labelText.trim());
        this.trigger('selected:printzone:change', this.model.get('id'), this.currentPzId, nbrColor);
        if (this.currentPzId !== '-1') {
          this.ui.uploadImageBlock.show();
        } else {
          this.ui.uploadImageBlock.hide();
          this.trigger('selected:printzone:image:change', this.model.get('id'), this.currentPzId, null);
        }
      },

      onDelete: function () {
        this.trigger('selected:printzone:image:change', this.model.get('id'), -1, null);
        this.ui.imageSelected.attr('src', '');
        this.ui.uploadImageBlock.show();
        this.ui.imageContainer.hide();
      }
    });
  });
